// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-basic{height:100%;display:flex;flex-direction:column}.layout-basic-content{flex:1;background-color:var(--greyColorBg)}", ""]);
// Exports
module.exports = exports;
